import { render, staticRenderFns } from "./sheetBg.vue?vue&type=template&id=2d08c815&scoped=true&"
import script from "./sheetBg.vue?vue&type=script&lang=js&"
export * from "./sheetBg.vue?vue&type=script&lang=js&"
import style0 from "./sheetBg.vue?vue&type=style&index=0&id=2d08c815&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08c815",
  null
  
)

export default component.exports